import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import gql from 'graphql-tag';
import { compose } from '../../../../src/web/utils/react';
import { widget } from '../../../../src/web/components/widgets/decorators';
import useQuery from '../../../../modules/react/hooks/useQuery';
import { BUILDER } from '../../../../src/shared/abilities';
import { NAME, ID } from './properties';
import PayOnline from './PayOnline';

const GET_PAY_ONLINE_DATA = gql`
  query GetPayOnlineData($locale: String!) {
    facilities {
      edges {
        node {
          id
          __typename
          page(locale: $locale) {
            ...PayOnlinePage
            __typename
          }
          ...PayOnlineFacility
        }
      }
    }
  }

  ${PayOnline.fragments.facility}
  ${PayOnline.fragments.page}
`;

const Pay = ({ payOption }) => {
  const { locale } = useIntl();

  const { data } = useQuery(GET_PAY_ONLINE_DATA, { variables: { locale } });

  if (!data) {
    return <PayOnline facilities={[]} />;
  }

  const facilities = data.facilities.edges.map(({ node }) => ({ ...node }));

  return <PayOnline facilities={facilities} payOption={payOption} />;
};

Pay.propTypes = {
  payOption: PropTypes.string.isRequired,
};

const component = compose(
  widget(
    { name: NAME, componentId: ID, deprecated: true },
    {
      defaults: {
        href: 'http://placehold.it/150x150',
      },
      menu: false,
    },
  ),
)(Pay);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
